import React from 'react';
import { Modal, Button } from '@arco-design/web-react';
import { IconLink } from '@arco-design/web-react/icon';
import { getApiUrl } from '@/config/api';
import './DocumentPreviewModal.css';

const buildFileUrl = (fileUrl) => {
  if (!fileUrl) return '';
  if (fileUrl.startsWith('http')) return fileUrl;
  return `${getApiUrl()}${fileUrl}`;
};

const getFileExtension = (fileName = '') => {
  const parts = fileName.split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

function DocumentPreviewModal({ visible, onClose, document, title }) {
  if (!document) return null;

  const fileUrl = buildFileUrl(document.file_url || document.file_path || '');
  const fileName = document.file_name || title || 'Documento';
  const extension = getFileExtension(fileName);
  const isPdf = extension === 'pdf';
  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension);

  return (
    <Modal
      title={title || fileName}
      visible={visible}
      onCancel={onClose}
      footer={null}
      style={{ width: '80vw', maxWidth: 980 }}
    >
      <div className="document-preview-body">
        {fileUrl ? (
          <>
            {isPdf && (
              <iframe
                title={fileName}
                src={fileUrl}
                className="document-preview-frame"
              />
            )}
            {isImage && (
              <img
                src={fileUrl}
                alt={fileName}
                className="document-preview-image"
              />
            )}
            {!isPdf && !isImage && (
              <div className="document-preview-fallback">
                <p>Previsualización no disponible para este formato.</p>
                <Button
                  type="primary"
                  icon={<IconLink />}
                  onClick={() => window.open(fileUrl, '_blank', 'noopener,noreferrer')}
                >
                  Abrir documento
                </Button>
              </div>
            )}
          </>
        ) : (
          <div className="document-preview-fallback">
            <p>No se encontró la URL del documento.</p>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default DocumentPreviewModal;
